'use client';

import { formatSecondsTime } from '@/utils';
import { Slider } from '@nextui-org/react';
import NextImage from 'next/image';
import clsx from 'clsx';

import { MindfulAudioImg } from '@/config/img/mindfulAudio';
import { useCallback } from 'react';
import { useClientTranslation } from '@/hook/translate';

export default function AudioBar(props: {
  url: string;
  className?: string;
  play: () => void;
  pause: () => void;
  duration: number;
  currentTime: number;
  changeCurrentTime: (value: number) => void;
  audioStatus: string;
}) {
  const {
    play,
    pause,
    duration,
    audioStatus,
    currentTime,
    changeCurrentTime,
  } = props;
  const imageLoader = useCallback(({ src }: { src: string }) => {
    return src;
  }, []);
  const { t } = useClientTranslation();

  return (
    <div className={
      clsx('audio-wrap flex items-center bg-white rounded-[40px] h-[90px]', props?.className)
    }>
      <div className=' min-w-[227px] h-[90px] bg-[#155FF9] flex items-center p-[7px] rounded-full'>
        {
          audioStatus === 'play' ?
            <NextImage
              loader={imageLoader}
              unoptimized
              alt='stop'
              src={MindfulAudioImg.StopBookey}
              width={76}
              height={76}
              className={props.url ? 'cursor-pointer rounded-full' : 'cursor-not-allowed'}
              onClick={pause}
            />
            :
            <NextImage
              loader={imageLoader}
              alt='play'
              src={MindfulAudioImg.PlayBookey}
              width={76}
              height={76}
              className={props.url ? 'cursor-pointer rounded-full' : 'cursor-not-allowed'}
              onClick={play} />
        }
        <span className='text-white font-bold text-18-24 pl-[10px]'>{ t('playSample', 'mindfulAudio') }</span>
      </div>
      <span onClick={pause} className='text-12-17 pl-5'>{formatSecondsTime(currentTime)}</span>
      <Slider
        size="sm"
        step={1}
        hideThumb={true}
        maxValue={duration}
        minValue={0}
        value={currentTime}
        onChange={(value) => changeCurrentTime(value as number)}
        aria-label="audio"
        className='pl-[10px] flex-1'
        classNames={{
          filler: 'bg-[#CDF564]',
          track: '!border-0',
          // track: 'bg-white',
        }}
      />
      <span onClick={pause} className='text-12-17 pr-8 pl-[10px]'>{formatSecondsTime(duration)}</span>
    </div>
  );
}
